import CopyTemplate from './copytemplate'

export default CopyTemplate